// src/app/redux/reducers/etablissementsReducer.js
import {
    FETCH_ETABLISSEMENTS_REQUEST,
    FETCH_ETABLISSEMENTS_SUCCESS,
    FETCH_ETABLISSEMENTS_FAIL,

    CREATE_ETABLISSEMENT_SUCCESS,
    CREATE_ETABLISSEMENT_FAIL,

    UPDATE_ETABLISSEMENT_SUCCESS,
    UPDATE_ETABLISSEMENT_FAIL,

    DELETE_ETABLISSEMENT_SUCCESS,
    DELETE_ETABLISSEMENT_FAIL,

    SET_ETABLISSEMENTS_LOADING,
} from "../actions/etablissementsActions";

const initialState = {
    etablissements: [],
    loading: false,
    error: null,
};

export default function etablissementsReducer(state = initialState, action) {
    switch (action.type) {
        case SET_ETABLISSEMENTS_LOADING:
            return { ...state, loading: !!action.payload };

        case FETCH_ETABLISSEMENTS_REQUEST:
            return { ...state, error: null };

        case FETCH_ETABLISSEMENTS_SUCCESS:
            return { ...state, etablissements: action.payload || [], error: null };

        case FETCH_ETABLISSEMENTS_FAIL:
            return { ...state, error: action.payload };

        case CREATE_ETABLISSEMENT_SUCCESS:
            // on laisse le saga re-fetch, mais on peut aussi injecter directement
            return { ...state, error: null };

        case CREATE_ETABLISSEMENT_FAIL:
            return { ...state, error: action.payload };

        case UPDATE_ETABLISSEMENT_SUCCESS:
            return { ...state, error: null };

        case UPDATE_ETABLISSEMENT_FAIL:
            return { ...state, error: action.payload };

        case DELETE_ETABLISSEMENT_SUCCESS:
            return {
                ...state,
                etablissements: (state.etablissements || []).filter((x) => x.id !== action.payload),
                error: null,
            };

        case DELETE_ETABLISSEMENT_FAIL:
            return { ...state, error: action.payload };

        default:
            return state;
    }
}
